import {route} from "ziggy-js";

export async function addOrUpdateBasket(values) {
    return axios.post(route('basket.addOrUpdate'), values);
}
